import { memo } from 'react';
import { Skeleton } from 'antd';
import './detail-skeleton.scss';

const DetailSkeleton = () => {
    return (
        <div className="dialogue-area-skeleton">
            <Skeleton.Input size="large" block active />
            <div className="dialogue-area-skeleton-content">
                <div className="dialogue-area-skeleton__user">
                    <Skeleton paragraph={false} title={{ width: '100px' }} active />
                </div>
                <div className="dialogue-area-skeleton__gpt">
                    <Skeleton paragraph={false} title={{ width: '120px' }} active />
                </div>
                <div className="dialogue-area-skeleton__gpt">
                    <Skeleton paragraph={false} title={{ width: '300px' }} active />
                </div>
                <div className="dialogue-area-skeleton__user">
                    <Skeleton paragraph={false} title={{ width: '100px' }} active />
                </div>
                <div className="dialogue-area-skeleton__gpt">
                    <Skeleton paragraph={false} title={{ width: '80px' }} active />
                </div>
                <div className="dialogue-area-skeleton__user">
                    <Skeleton paragraph={false} title={{ width: '160px' }} active />
                </div>
                <div className="dialogue-area-skeleton__gpt">
                    <Skeleton paragraph={false} title={{ width: '320px' }} active />
                </div>
                <div className="dialogue-area-skeleton__user">
                    <Skeleton paragraph={false} title={{ width: '100px' }} active />
                </div>
            </div>
            <Skeleton.Input size="large" block active />
        </div>
    );
};

export default memo(DetailSkeleton);
